import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef, useState } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import {
  phoneValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closed } from "../../components/drawer/drawerSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import { DEPOSITED_MODE, TOPUP_REQUEST_TYPE } from "../../_contstants/common";
import FormDatePicker from "../../components/formFields/FormDateField";

import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import FormRadioGroup from "../../components/formFields/FormRadioGroup";
import { getCustomerDetailFromMobileNo } from "../userManagement/services/userManagement.services";
import {
  clearTopupRequestDetails,
  clearTopupRequestID,
} from "./topupRequestSlice";
import {
  getAllTopupRequests,
  getTopupRequestByID,
  insertTopupRequest,
  updateTopupRequest,
} from "./services/topuprequest.services";
import { formatIndianNumber } from "../../_helper/helper";
import { getAllActiveBankAccounts } from "../bankaccount/services/bankaccount.services";
import { getAllActiveBanks } from "../bank/services/bank.services";
import { IBankAccount } from "../bankaccount/bankaccountModel";
import { IBank } from "../bank/bankModel";
import FormTextArea from "../../components/formFields/FormTextArea";
import { ErrorToast } from "../../components/toast/Toasts";
import moment from "moment";

const CreateTopupRequest: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const TopupRequestFilterDetails = useAppSelector(
    (state) => state.topuprequest.TopupRequestFilterDetails
  );

  const isIndirect = useAppSelector((state) => state.drawer.isIndirect);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const TopupRequestDetails = useAppSelector(
    (state) => state.topuprequest.TopupRequestDetails
  );
  const TopupRequestID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.topuprequest.formLoading);
  const loading = useAppSelector((state) => state.userM.formloading);
  const BankList = useAppSelector((state) => state.bank.BankList);
  const BankAccountList = useAppSelector(
    (state) => state.bankaccount.BankAccountList
  );

  const [btnType, setBtnType] = useState(1);
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    dispatch(getAllActiveBankAccounts());
    dispatch(getAllActiveBanks());
    return () => {
      if (!isIndirect) {
        dispatch(clearTopupRequestDetails());
        dispatch(clearTopupRequestID());
      }
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (TopupRequestID) {
      dispatch(getTopupRequestByID(TopupRequestID));
    }
  }, [TopupRequestID]);

  useEffect(() => {
    setFormKey((prevKey) => prevKey + 1);
  }, [TopupRequestDetails]);

  const handleGetUserDetails = async (
    mobileno: string,
    formRenderProps: FormRenderProps
  ) => {
    setBtnType(1);
    if (mobileno) {
      const response = await dispatch(getCustomerDetailFromMobileNo(mobileno));
      formRenderProps.onChange("CustomerDetails", { value: response.payload });
    }
  };

  const handleSubmit = async (values: any) => {
    if (btnType === 2) {
      try {
        if (!TopupRequestID) {
          if (!values?.CustomerDetails?.mobile_no) {
            ErrorToast("Enter Valid Customer Mobile no");
            return;
          }

          const payload = {
            BankID: values?.BankID ? Number(values.BankID) : null,
            DepositedBankID: values?.DepositedBankID
              ? Number(values.DepositedBankID)
              : null,
            Amount: Number(values.Amount),
            TransactionDate: values.TransactionDate
              ? moment(values.TransactionDate).format("YYYY-MM-DD")
              : "",
            ChequeNo: values?.ChequeNo,
            DepositedBranch: values?.DepositedBranch,
            ChequeBranchName: values?.ChequeBranchName,
            AccHoloderName: values?.AccHoloderName,
            AccountNo: values?.AccountNo,
            Remarks: values?.Remarks,
            NetTransferID: values?.NetTransferID,
            TransactionNo: values?.TransactionNo,
            DepositedMode: values?.DepositedMode,
            Type: values?.Type,
            CustomerID: values?.CustomerDetails?.id,
            EmployeeID: localStorage.getItem("UserID"),
          };

          const response = await dispatch(insertTopupRequest(payload));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(closed());
            dispatch(clearTopupRequestDetails());
            const payload = {
              ...TopupRequestFilterDetails,
              FromDate: TopupRequestFilterDetails?.FromDate
                ? moment(TopupRequestFilterDetails?.FromDate).format(
                    "YYYY-MM-DD"
                  )
                : "",
              ToDate: TopupRequestFilterDetails?.ToDate
                ? moment(TopupRequestFilterDetails?.ToDate).format("YYYY-MM-DD")
                : "",
              Limit: +pageLimit,
              Skip: +currentPage * +pageLimit,
            };
            if (isIndirect) {
              dispatch(getTopupRequestByID(TopupRequestID));
            } else {
              dispatch(getAllTopupRequests(payload));
            }
          }
        } else {
          const payload = {
            ID: TopupRequestID,
            BankID: values?.BankID ? Number(values.BankID) : null,
            DepositedBankID: values?.DepositedBankID
              ? Number(values.DepositedBankID)
              : null,
            Amount: Number(values.Amount),
            TransactionDate: values.TransactionDate
              ? moment(values.TransactionDate).format("YYYY-MM-DD")
              : "",
            ChequeNo: values?.ChequeNo,
            DepositedBranch: values?.DepositedBranch,
            ChequeBranchName: values?.ChequeBranchName,
            AccHoloderName: values?.AccHoloderName,
            AccountNo: values?.AccountNo,
            Remarks: values?.Remarks,
            NetTransferID: values?.NetTransferID,
            TransactionNo: values?.TransactionNo,
            DepositedMode: values?.DepositedMode,
            Type: values?.Type,
            CustomerID: values?.CustomerID,
            EmployeeID: localStorage.getItem("UserID"),
          };
          const response = await dispatch(updateTopupRequest(payload));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(closed());
            dispatch(clearTopupRequestDetails());
            const payload = {
              ...TopupRequestFilterDetails,
              FromDate: TopupRequestFilterDetails?.FromDate
                ? moment(TopupRequestFilterDetails?.FromDate).format(
                    "YYYY-MM-DD"
                  )
                : "",
              ToDate: TopupRequestFilterDetails?.ToDate
                ? moment(TopupRequestFilterDetails?.ToDate).format("YYYY-MM-DD")
                : "",
              Limit: +pageLimit,
              Skip: +currentPage * +pageLimit,
            };
            if (isIndirect) {
              dispatch(getTopupRequestByID(TopupRequestID));
            } else {
              dispatch(getAllTopupRequests(payload));
            }
          }
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  return (
    <>
      {(formLoading || loading) && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={TopupRequestDetails}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ width: "100%" }}>
            <GridLayout
              style={{
                marginRight: 10,
              }}
              gap={{ rows: 10, cols: 10 }}
              cols={[{ width: "50%" }, { width: "50%" }]}
            >
              <GridLayoutItem className="master-drawer-header" colSpan={2}>
                <Typography.h4 className="m-0">
                  {TopupRequestID
                    ? "Update Topup Request"
                    : "Create Topup Request"}
                </Typography.h4>
                <Button
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                >
                  <RxCross1 />
                </Button>
              </GridLayoutItem>
              <GridLayoutItem
                colSpan={2}
                className="d-flex gap-3 align-items-start"
              >
                <Field
                  name="CustomerMobileNo"
                  type="number"
                  max="10"
                  wrapperClassName="w-50"
                  placeholder=" i.e 9999999999"
                  label="Mobile No"
                  astrike={true}
                  validator={phoneValidator}
                  component={FormTextField}
                  disabled={TopupRequestID}
                />
                {!TopupRequestID && (
                  <Button
                    type="submit"
                    fillMode={"solid"}
                    themeColor={"primary"}
                    style={{ marginTop: 34 }}
                    onClick={() =>
                      handleGetUserDetails(
                        formRenderProps.valueGetter("CustomerMobileNo"),
                        formRenderProps
                      )
                    }
                    disabled={formLoading}
                  >
                    View
                  </Button>
                )}
              </GridLayoutItem>
              {(formRenderProps.valueGetter("CustomerDetails") ||
                TopupRequestID) && (
                <>
                  <GridLayoutItem
                    colSpan={2}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: 10,
                      background: "gainsboro",
                      borderRadius: "4px",
                      padding: "8px",
                    }}
                  >
                    <div>
                      <Typography.h5>
                        Customer Name :{" "}
                        {!TopupRequestID
                          ? formRenderProps.valueGetter("CustomerDetails")
                              ?.first_name
                          : TopupRequestDetails?.CustomerName}{" "}
                        {!TopupRequestID &&
                          formRenderProps.valueGetter("CustomerDetails")
                            ?.last_name}
                      </Typography.h5>
                    </div>
                    <div className="d-flex gap-5">
                      <Typography.h6 style={{ fontSize: 16 }}>
                        Details :{" "}
                      </Typography.h6>
                      <div className="d-flex flex-column">
                        <strong style={{ fontSize: 16, fontWeight: 700 }}>
                          ₹{" "}
                          {!TopupRequestID
                            ? formatIndianNumber(
                                formRenderProps.valueGetter("CustomerDetails")
                                  ?.CreditLimit || 0
                              )
                            : formatIndianNumber(
                                TopupRequestDetails?.CreditLimitAmount || 0
                              )}
                        </strong>
                        <span style={{ fontSize: 12 }}>Limit Given</span>
                      </div>
                      <div className="d-flex flex-column">
                        <strong style={{ fontSize: 16, fontWeight: 700 }}>
                          ₹{" "}
                          {!TopupRequestID
                            ? formatIndianNumber(
                                formRenderProps.valueGetter("CustomerDetails")
                                  ?.wallet_balance || 0
                              )
                            : formatIndianNumber(
                                TopupRequestDetails?.WalletBalance || 0
                              )}
                        </strong>
                        <span style={{ fontSize: 12 }}>Wallet Balance</span>
                      </div>
                      <div className="d-flex flex-column">
                        <strong style={{ fontSize: 16, fontWeight: 700 }}>
                          ₹{" "}
                          {!TopupRequestID
                            ? formatIndianNumber(
                                formRenderProps.valueGetter("CustomerDetails")
                                  ?.OutStandingAmount || 0
                              )
                            : formatIndianNumber(
                                TopupRequestDetails?.OutStandingAmount || 0
                              )}
                        </strong>
                        <span style={{ fontSize: 12 }}>Outstanding Amount</span>
                      </div>
                    </div>
                  </GridLayoutItem>
                  {/* {!TopupRequestID && ( */}
                  <GridLayoutItem
                    colSpan={2}
                    className="flight-search-radio-griditem"
                  >
                    <Field
                      id={"Type"}
                      name={"Type"}
                      component={FormRadioGroup}
                      options={TOPUP_REQUEST_TYPE}
                      disabled={TopupRequestID}
                    />
                  </GridLayoutItem>
                  {/* )} */}
                  {formRenderProps.valueGetter("Type") === "Cheque" && (
                    <>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name="ChequeNo"
                          label="Cheque No"
                          component={FormTextField}
                          placeholder="Cheque No"
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"TransactionDate"}
                          component={FormDatePicker}
                          label={"Cheque Date Of Transction"}
                          validator={requiredValidator}
                          astrike={true}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"DepositedBankID"}
                          label={"Deposited Bank"}
                          component={FormSelectionField}
                          placeholder="Deposited Bank"
                          astrike={true}
                          validator={requiredValidator}
                          options={BankAccountList.map(
                            (account: IBankAccount) => {
                              return {
                                value: account.ID,
                                label: `${account?.BankName} - ${account?.AccountNo}`,
                              };
                            }
                          )}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"DepositedBranch"}
                          label={"Deposited Branch"}
                          component={FormTextField}
                          placeholder="Deposited Branch"
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"BankID"}
                          label={"Bank"}
                          component={FormSelectionField}
                          placeholder="Bank"
                          astrike={true}
                          validator={requiredValidator}
                          options={BankList.map((bank: IBank) => {
                            return {
                              value: bank.ID,
                              label: bank?.BankName,
                            };
                          })}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"ChequeBranchName"}
                          label={"Cheque Branch"}
                          component={FormTextField}
                          placeholder="Cheque Branch"
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"AccHoloderName"}
                          label={"Acc Holder Name"}
                          component={FormTextField}
                          placeholder="Acc Holder Name"
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"AccountNo"}
                          label={"Account No"}
                          component={FormTextField}
                          placeholder="Account No"
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                    </>
                  )}
                  {formRenderProps.valueGetter("Type") === "Net Transfer" && (
                    <>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name="NetTransferID"
                          label="Net Transfer ID"
                          component={FormTextField}
                          placeholder="Net Transfer ID"
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name="TransactionDate"
                          label="Net Transfer Date Of Transaction"
                          component={FormDatePicker}
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"BankID"}
                          label={"Bank"}
                          component={FormSelectionField}
                          placeholder="Bank"
                          astrike={true}
                          validator={requiredValidator}
                          options={BankList.map((bank: IBank) => {
                            return {
                              value: bank.ID,
                              label: bank?.BankName,
                            };
                          })}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"DepositedBankID"}
                          label={"Deposited Bank"}
                          component={FormSelectionField}
                          placeholder="Deposited Bank"
                          astrike={true}
                          validator={requiredValidator}
                          options={BankAccountList.map(
                            (account: IBankAccount) => {
                              return {
                                value: account.ID,
                                label: `${account?.BankName} - ${account?.AccountNo}`,
                              };
                            }
                          )}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"AccHoloderName"}
                          label={"Acc Holder Name"}
                          component={FormTextField}
                          placeholder="Acc Holder Name"
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"AccountNo"}
                          label={"Account No"}
                          component={FormTextField}
                          placeholder="Account No"
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                    </>
                  )}
                  {formRenderProps.valueGetter("Type") === "Cash" && (
                    <>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name="TransactionNo"
                          label="Transaction No"
                          component={FormTextField}
                          placeholder="Transaction No"
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name="TransactionDate"
                          label="Cash Date Of Transction"
                          component={FormDatePicker}
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"DepositedBankID"}
                          label={"Deposited Bank"}
                          component={FormSelectionField}
                          placeholder="Deposited Bank"
                          astrike={true}
                          validator={requiredValidator}
                          options={BankAccountList.map(
                            (account: IBankAccount) => {
                              return {
                                value: account.ID,
                                label: `${account?.BankName} - ${account?.AccountNo}`,
                              };
                            }
                          )}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"DepositedBranch"}
                          label={"Deposited Branch"}
                          component={FormTextField}
                          placeholder="Deposited Branch"
                          validator={requiredValidator}
                          astrike={true}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"DepositedMode"}
                          label={"Deposited Mode"}
                          component={FormSelectionField}
                          placeholder="Deposited Mode"
                          astrike={true}
                          validator={requiredValidator}
                          options={DEPOSITED_MODE.map((type: any) => {
                            return {
                              value: type.value,
                              label: type.label,
                            };
                          })}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name={"AccountNo"}
                          label={"Account No"}
                          component={FormTextField}
                          placeholder="Account No"
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                    </>
                  )}
                  {formRenderProps.valueGetter("Type") === "Other" && (
                    <>
                      <GridLayoutItem colSpan={1}>
                        <Field
                          name="TransactionDate"
                          label="Other Date Of Transcation"
                          component={FormDatePicker}
                          astrike={true}
                          validator={requiredValidator}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}></GridLayoutItem>
                    </>
                  )}
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name="Remarks"
                      label="Remarks"
                      component={FormTextArea}
                      placeholder="Remarks"
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={1}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px",
                    }}
                  >
                    <Field
                      name="Amount"
                      label="Amount"
                      component={FormNumericTextField}
                      placeholder="Amount"
                      astrike={true}
                      min={0}
                      validator={requiredValidator}
                    />
                    <div
                      style={{
                        textAlign: "end",
                        width: "100%",
                      }}
                    >
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginRight: 4 }}
                        onClick={handleFormClose}
                      >
                        Cancel
                      </Button>
                      <ButtonWithLoading
                        label={TopupRequestID ? "Update" : "Create"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || formLoading}
                        loading={formLoading}
                        onClick={() => setBtnType(2)}
                      />
                    </div>
                  </GridLayoutItem>
                </>
              )}
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateTopupRequest;
